<template>
    <llp-header :menuOptions="menuOptions" :userName="userName"></llp-header>
    <div :id="id" class="llp-page container-fluid">
        <p class="h4 m-2 m-lg-3">{{ startCase(pageName) }}</p>
        <slot name="body"></slot>
    </div>
    <llp-footer></llp-footer>
    <llp-toast ref="toast"></llp-toast>

    <!-- popup is unique per page -->
    <llp-popup ref="popup"></llp-popup>
</template>

<script>
import ErrorService from '../../services/error.service';

export default {
  name: 'BasePage',
  props: {
    id: {
      type: String,
      required: true,
    },
    pageName: {
      type: String,
      required: true,
    },
    userName: {
      type: String,
      required: true,
    },
    menuOptions: {
      type: Object,
      required: true,
    },
  },
  data: function() {
    return {};
  },
  methods: {
    showError: function(error) {
      let messages = ErrorService.getErrorMessages(error);

      if (!this.$_.isEmpty(messages)) {
        return this.$refs.toast.show(messages, 'error');
      }
    },
    showWarning: function(message) {
      return this.$refs.toast.show(message, 'warning');
    },
    showInfo: function(message) {
      return this.$refs.toast.show(message, 'info');
    },
    showSuccess: function(message) {
      return this.$refs.toast.show(message);
    },
    showDeletePopup: function(title, message, callBack) {
      this.$refs.popup.showPopup(title,
          '<span>' + message + '</span>',
          callBack);
    },
    showInfoPopup: function(title, body, callBack, cancelCallback) {
      this.$refs.popup.showPopup(title, body, callBack, 'info', cancelCallback);
    },
    showConfirmationPopup: function(title, body) {
      this.$refs.popup.showPopup(title, body, null, 'confirm');
    },
    startCase: function(str) {
      if (!str) return '';

      return str
          .split('-')
          .map(word => this.$_.startCase(word))
          .join('-');
    },
  },
};
</script>
